import { BehaviorSubject, timer, Observable, Subscription } from 'rxjs';
import { takeWhile } from 'rxjs/operators';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class LoadingService {
  public loading: BehaviorSubject<boolean> = new BehaviorSubject(false);
  public progress: BehaviorSubject<number> = new BehaviorSubject(0);
  public timer: Observable<number>;
  public completing: BehaviorSubject<boolean> = new BehaviorSubject(false);
  public loadingTimerSubscription: Subscription;
  public completingTimerSubscription: Subscription;
  private incrementMod: number;

  constructor() { }

  public async loadWhileFetching(promise: Promise<any>) {
    this.startLoading();

    try {
      const result = await promise;
      this.completeLoading();

      return result;
    } catch (e) {
      this.completeLoading();
      throw e;
    }
  }

  public startLoading() {
    if (this.loading.getValue()) {
      this.completeLoading(false);
    }

    this.incrementMod = 5;
    this.progress.next(10);
    this.loading.next(true);
    this.completing.next(true);
    this.timer = timer(0, 100);
    this.loadingTimerSubscription = this.timer
      .pipe(
        takeWhile(() => this.completing.getValue() && this.incrementMod > 0.0001),
      )
      .subscribe(() => {
        this.updateProgress();
      });
  }

  public completeLoading(success: boolean = true) {
    if (!success) {
      return this.stopLoading();
    }

    const timerComplete = timer(0, 30);

    this.completingTimerSubscription = timerComplete
      .pipe(
        takeWhile((val) => val < 12 && this.completing.getValue()),
      )
      .subscribe(() => {
        this.progress.next(this.progress.getValue() + 20);
      }, null, () => {
        this.stopLoading();
      });
  }

  private stopLoading() {
    this.progress.next(10);
    this.loading.next(false);
    this.completing.next(false);
    this.loadingTimerSubscription.unsubscribe();
    this.completingTimerSubscription.unsubscribe();
  }

  private updateProgress(completing?: boolean) {
    const currentProgress = this.progress.getValue();
    if (currentProgress > 50 && !completing) {
      this.incrementMod *= this.incrementMod < 0.5 ? 0.95 : 0.8;
    }

    this.progress.next(currentProgress + (1 * this.incrementMod));
  }
}
